import React, { useState, useEffect } from "react";
import { Container, Row, Col, Nav, Table } from "react-bootstrap";
import { Buttons } from "../components/Buttons";
import { useNavigate, Navigate } from "react-router-dom";
import API_DOMAIN from "../config/config";
import { ExpenseExcel } from "./expenseexcel";
import { downloadPurchaseExcel } from "./purchaseexccel";
import { downloadSalesExcel } from "./salesexcel";
import { downloadStockExcel } from "./stockexcel";
import "../components/Table.css";
import {
  Calender,
  LoadingSpinner,
  DropDownUI,
  formatDate,
} from "../components/Forms";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SaleRep from "../pages/SaleRep";
import PurchaseReport from "./PurchaseReport";
import StockPDF from "./StockPDF";
import ExpensePDF from "./expensepdf";
import OnlineSalesPDF from "./OnlineSalesPDF";
import { downloadOnlineSalesExcel } from "./OnlineSalesExcel";
import moment from "moment";
import companyId from "../config/companyId";
import { Badge } from "react-bootstrap";

const Reports = () => {
  const [activeTab, setActiveTab] = useState("sales");
  const navigate = useNavigate();
  const [loadingStock, setLoadingStock] = useState(false);
  const [loadingSales, setLoadingSales] = useState(false);
  const [loadingPurchase, setLoadingPurchase] = useState(false);
  const [loadingExpense, setLoadingExpense] = useState(false);
  const [loadingOnlineSales, setLoadingOnlineSales] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);

  // Consolidated form data states
  const initialFormData = {
    party_name: "",
    party_id: "",
    product_id: "",
    category_id: "",
    bill_date: "",
    fromdate: "",
    todate: "",
    gst_filter: "",
  };
  const [formDataSales, setFormDataSales] = useState({ ...initialFormData });
  const [formDataPurchase, setFormDataPurchase] = useState({
    ...initialFormData,
  });
  const [formDataStock, setFormDataStock] = useState({ ...initialFormData });
  const [formDataExpense, setFormDataExpense] = useState({
    ...initialFormData,
  });
  const [formDataOnlineSales, setFormDataOnlineSales] = useState({
    ...initialFormData,
    customer_name: "",
  });
  const [dropdownKey, setDropdownKey] = useState(Date.now());

  // Data states
  const [userDataSalesParty, setUserDataSalesParty] = useState([]);
  const [userDataPurchaseParty, setUserDataPurchaseParty] = useState([]);
  const [userDataProduct, setUserDataProduct] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [stockDataPurchase, setStockDataPurchase] = useState([]);
  const [stockDataProductSales, setStockDataProductSales] = useState([]);
  const [stockDataProductPurchase, setStockDataProductPurchase] = useState([]);
  const [productData, setProductData] = useState([]);
  const [expItemData, setExpItemData] = useState([]);
  const [expCategoryData, setExpCategoryData] = useState([]);
  const [onlineSalesData, setOnlineSalesData] = useState([]);
  // Add this near your other useState definitions
  const [partyDropdownOptions, setPartyDropdownOptions] = useState([]);
  // Generic date and form field handlers
  const setDate = (date, field, formSetter) => {
    formSetter((prev) => ({ ...prev, [field]: date }));
  };

  const setFormField = (value, field, formSetter) => {
    formSetter((prev) => ({ ...prev, [field]: value }));
  };

  // Session check
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  // Sales data fetch
  const fetchAllSalesData = async () => {
    setLoadingSales(true);
    try {
      const salesInvoiceResponse = await fetch(
        `${API_DOMAIN}/salesinvoice.php?id=${companyId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            search_text: "",
            party_name: "",
            from_date: formDataSales.fromdate || "",
            to_date: formDataSales.todate || "",
            bill_no: "",
          }),
        }
      );
      const invoiceData = await salesInvoiceResponse.json();
      if (invoiceData?.status === 200 && Array.isArray(invoiceData.data)) {
        const uniquePartiesMap = new Map();
        invoiceData.data.forEach((item) => {
          const partyId = item.party_details.party_id;

          if (!uniquePartiesMap.has(partyId)) {
            uniquePartiesMap.set(partyId, {
              value: partyId,
              label: item.party_name,
            });
          }
        });

        const uniquePartyOptions = Array.from(uniquePartiesMap.values());
        setPartyDropdownOptions(uniquePartyOptions);
        let sortedData = invoiceData.data;

        if (formDataSales.party_id) {
          sortedData = sortedData.filter(
            (item) => item.party_details.party_id === formDataSales.party_id
          );
        }
        if (formDataSales.fromdate) {
          const fromDate = moment(formDataSales.fromdate, "YYYY-MM-DD");
          sortedData = sortedData.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrAfter(fromDate)
          );
        }

        if (formDataSales.todate) {
          const toDate = moment(formDataSales.todate, "YYYY-MM-DD");
          sortedData = sortedData.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrBefore(toDate)
          );
        }
        if (formDataSales.gst_filter) {
          sortedData = sortedData.filter((item) => {
            const gst = parseFloat(item.gst_amount || 0);

            if (formDataSales.gst_filter === "with") {
              return gst > 0;
            }

            if (formDataSales.gst_filter === "without") {
              return gst === 0;
            }

            return true; // Fallback safety net
          });
        }
        console.log("Filtered Sales Data:", sortedData);
        setStockData(sortedData);
      } else {
        setStockData([]);
        setPartyDropdownOptions([]);
      }
    } catch (error) {
      setStockData([]);
      setPartyDropdownOptions([]);
    } finally {
      setLoadingSales(false);
    }
  };

  // Online Enquiry Fetch
  const fetchOnlineSalesData = async () => {
    setLoadingOnlineSales(true);
    try {
      const response = await fetch(
        `${API_DOMAIN}/online_enquiry.php?id=${companyId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            search_text: "",
            customer_name: formDataOnlineSales.customer_name || "",
            from_date: formDataOnlineSales.fromdate || "",
            to_date: formDataOnlineSales.todate || "",
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.head.code === 200) {
        let filteredData = responseData.body.enquiry || [];

        // Apply filters
        if (formDataOnlineSales.customer_name) {
          filteredData = filteredData.filter(
            (item) => item.customer_name === formDataOnlineSales.customer_name
          );
        }
        // Helper to normalize date from API
        const parseApiDate = (item) => {
          if (item.bill_date) {
            // Check if it's ISO (YYYY-MM-DD) or DD/MM/YYYY
            return moment(item.bill_date, ["YYYY-MM-DD", "DD/MM/YYYY"], true);
          } else if (item.created_date) {
            return moment(item.created_date, "DD/MM/YYYY");
          }
          return null;
        };

        if (formDataOnlineSales.fromdate) {
          const fromDate = moment(formDataOnlineSales.fromdate, "YYYY-MM-DD");
          filteredData = filteredData.filter((item) => {
            const parsed = parseApiDate(item);
            return parsed && parsed.isSameOrAfter(fromDate);
          });
        }

        if (formDataOnlineSales.todate) {
          const toDate = moment(formDataOnlineSales.todate, "YYYY-MM-DD");
          filteredData = filteredData.filter((item) => {
            const parsed = parseApiDate(item);
            return parsed && parsed.isSameOrBefore(toDate);
          });
        }

        setOnlineSalesData(filteredData);
      } else {
        throw new Error(
          responseData.msg || "Failed to fetch online enquiry data"
        );
      }
    } catch (error) {
      setOnlineSalesData([]);
    } finally {
      setLoadingOnlineSales(false);
    }
  };

  // Purchase data fetch
  const fetchAllPurchaseData = async () => {
    setLoadingPurchase(true);
    try {
      const [partyRes, billRes] = await Promise.all([
        fetch(`${API_DOMAIN}/purchase_party.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "", company_id: companyId }),
        }),
        fetch(`${API_DOMAIN}/purchase_bill.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
      ]);

      const partyData = await partyRes.json();
      const billData = await billRes.json();

      if (partyData.status === 200) {
        setUserDataPurchaseParty(partyData.data);
      } else {
        throw new Error(partyData.msg || "Failed to fetch purchase parties");
      }

      if (billData && billData.data) {
        let filtered = billData.data;
        if (formDataPurchase.party_id) {
          filtered = filtered.filter(
            (item) => item.party_id === formDataPurchase.party_id
          );
        }
        if (formDataPurchase.fromdate) {
          const fromDate = moment(
            formDataPurchase.fromdate,
            "YYYY-MM-DD"
          ).startOf("day");
          filtered = filtered.filter((item) => {
            const billDate = moment(item.bill_date, [
              "YYYY-MM-DD",
              "DD-MM-YYYY",
              "YYYY/MM/DD",
            ]).startOf("day");
            return billDate.isSameOrAfter(fromDate);
          });
        }

        if (formDataPurchase.todate) {
          const toDate = moment(formDataPurchase.todate, "YYYY-MM-DD").endOf(
            "day"
          );
          filtered = filtered.filter((item) => {
            const billDate = moment(item.bill_date, [
              "YYYY-MM-DD",
              "DD-MM-YYYY",
              "YYYY/MM/DD",
            ]).endOf("day");
            return billDate.isSameOrBefore(toDate);
          });
        }

        setStockDataPurchase(filtered);
      } else {
        throw new Error("No purchase data found");
      }
    } catch (err) {
      setStockDataPurchase([]);
    } finally {
      setLoadingPurchase(false);
    }
  };

  // Stock data fetch
  const fetchAllStockData = async () => {
    setLoadingStock(true);
    try {
      const [productRes, salesRes, purchaseRes] = await Promise.all([
        fetch(`${API_DOMAIN}/products.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
        fetch(`${API_DOMAIN}/salesinvoice.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            search_text: "",
            party_id: "",
            from_date: "",
            to_date: "",
          }),
        }),
        fetch(`${API_DOMAIN}/purchase_bill.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
      ]);

      const productData = await productRes.json();
      const salesData = await salesRes.json();
      const purchaseData = await purchaseRes.json();

      if (productData.status === 200) {
        setUserDataProduct(productData.data);
        setProductData(productData.data);
      } else {
        throw new Error(productData.msg || "Failed to fetch products");
      }

      let filteredSales = salesData?.data || [];
      let filteredPurchase = purchaseData?.data || [];

      if (formDataStock.product_id) {
        filteredSales = filteredSales.filter((item) =>
          item.product.some((p) => p.product_id === formDataStock.product_id)
        );
        filteredPurchase = filteredPurchase.filter((item) =>
          item.product.some((p) => p.product_id === formDataStock.product_id)
        );
      }
      if (formDataStock.fromdate) {
        const fromDate = moment(formDataStock.fromdate, "YYYY-MM-DD");
        filteredSales = filteredSales.filter((item) =>
          moment(item.bill_date, "YYYY-MM-DD").isSameOrAfter(fromDate)
        );
        filteredPurchase = filteredPurchase.filter((item) =>
          moment(item.bill_date, "YYYY-MM-DD").isSameOrAfter(fromDate)
        );
      }
      if (formDataStock.todate) {
        const toDate = moment(formDataStock.todate, "YYYY-MM-DD");
        filteredSales = filteredSales.filter((item) =>
          moment(item.bill_date, "YYYY-MM-DD").isSameOrBefore(toDate)
        );
        filteredPurchase = filteredPurchase.filter((item) =>
          moment(item.bill_date, "YYYY-MM-DD").isSameOrBefore(toDate)
        );
      }

      setStockDataProductSales(
        filteredSales.map((item) => ({ ...item, type: "outward" }))
      );
      setStockDataProductPurchase(
        filteredPurchase.map((item) => ({ ...item, type: "inward" }))
      );
    } catch (error) {
      setStockDataProductSales([]);
      setStockDataProductPurchase([]);
    } finally {
      setLoadingStock(false);
    }
  };

  // Expense data fetch
  const fetchAllExpenseData = async () => {
    setLoadingExpense(true);
    try {
      const [categoryRes, itemRes] = await Promise.all([
        fetch(`${API_DOMAIN}/expensecategory.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
        fetch(`${API_DOMAIN}/expenseitem.php?id=${companyId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ search_text: "" }),
        }),
      ]);

      const categoryData = await categoryRes.json();
      const itemData = await itemRes.json();

      if (categoryData.status === 200) {
        setExpCategoryData(categoryData.data);
      } else {
        throw new Error(categoryData.msg || "Category fetch failed");
      }

      if (itemData.status === 200) {
        let filteredItems = itemData.data;
        if (formDataExpense.category_id) {
          filteredItems = filteredItems.filter(
            (item) => item.category_id === formDataExpense.category_id
          );
        }
        if (formDataExpense.fromdate) {
          const fromDate = moment(formDataExpense.fromdate, "YYYY-MM-DD");
          filteredItems = filteredItems.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrAfter(fromDate)
          );
        }
        if (formDataExpense.todate) {
          const toDate = moment(formDataExpense.todate, "YYYY-MM-DD");
          filteredItems = filteredItems.filter((item) =>
            moment(item.bill_date, "YYYY-MM-DD").isSameOrBefore(toDate)
          );
        }
        setExpItemData(filteredItems);
      } else {
        throw new Error(itemData.msg || "Item fetch failed");
      }
    } catch (error) {
      setExpItemData([]);
    } finally {
      setLoadingExpense(false);
    }
  };

  // Fetch data based on active tab
  useEffect(() => {
    if (activeTab === "sales") {
      fetchAllSalesData();
    } else if (activeTab === "purchase") {
      fetchAllPurchaseData();
    } else if (activeTab === "Stock") {
      fetchAllStockData();
    } else if (activeTab === "expense") {
      fetchAllExpenseData();
    } else if (activeTab === "online_sales") {
      fetchOnlineSalesData();
    }
  }, [
    activeTab,
    formDataSales,
    formDataPurchase,
    formDataStock,
    formDataExpense,
    formDataOnlineSales,
  ]);

  // Reset filters
  const handleClearFilters = (formSetter, initialData) => {
    formSetter({ ...initialData });
    setDropdownKey(Date.now());
  };

  // Render content based on active tab
  const renderContent = () => {
    if (loadingStock && activeTab === "Stock") {
      return <LoadingSpinner message="Loading Stock Report..." />;
    }
    if (loadingSales && activeTab === "sales") {
      return <LoadingSpinner message="Loading Sales Report..." />;
    }
    if (loadingOnlineSales && activeTab === "online_sales") {
      return <LoadingSpinner message="Loading Online Sales Report..." />;
    }

    if (loadingPurchase && activeTab === "purchase") {
      return <LoadingSpinner message="Loading Purchase Report..." />;
    }
    if (loadingExpense && activeTab === "expense") {
      return <LoadingSpinner message="Loading Expense Report..." />;
    }

    // Helper function to generate dynamic PDF filename for sales
    const getSalesPDFFilename = (fromDate, toDate) => {
      if (!fromDate || !toDate) {
        return "sales_report.pdf";
      }
      const start = moment(fromDate, "YYYY-MM-DD");
      const end = moment(toDate, "YYYY-MM-DD");
      const startMonth = start.format("MMM").toLowerCase();
      const endMonth = end.format("MMM").toLowerCase();
      if (start.isSame(end, "month")) {
        return `sales_${startMonth}.pdf`;
      } else {
        return `sales_${startMonth}_to_${endMonth}.pdf`;
      }
    };

    switch (activeTab) {
      case "Stock":
        return (
          <div className="all_report_table main my-2">
            <Row className="mx-2">
              <Col lg="12">
                <div className="fw-bold fs-5 mb-3">Stock Report</div>
              </Col>
              <Col lg="3">
                <DropDownUI
                  key={dropdownKey}
                  optionlist={userDataProduct.map((item) => ({
                    label: item.product_name,
                    value: item.product_id,
                  }))}
                  placeholder="Select Product"
                  labelname="Product"
                  name="product_id"
                  value={formDataStock.product_id || ""}
                  onChange={(updatedFormData) =>
                    setFormField(
                      updatedFormData.product_id,
                      "product_id",
                      setFormDataStock
                    )
                  }
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "fromdate", setFormDataStock)
                  }
                  selectedDate={formDataStock.fromdate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "fromdate", setFormDataStock)
                  }
                  calenderlabel="From Date"
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) => setDate(date, "todate", setFormDataStock)}
                  selectedDate={formDataStock.todate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "todate", setFormDataStock)
                  }
                  calenderlabel="To Date"
                />
              </Col>
              <Col lg="3" className="d-flex align-items-end">
                <Buttons
                  lable="Clear"
                  onClick={() =>
                    handleClearFilters(setFormDataStock, { ...initialFormData })
                  }
                />
              </Col>
              <Col lg="6">
                <Buttons
                  lable={<>Download Excel</>}
                  onClick={() => downloadStockExcel(productData)}
                />
              </Col>
              <Col lg="6">
                <div className="text-end mx-2">
                  <PDFDownloadLink
                    document={<StockPDF data={productData} />}
                    fileName="StockReport.pdf"
                  >
                    {({ url }) => (
                      <a
                        role="button"
                        tabIndex="0"
                        href={url}
                        rel="noopener noreferrer"
                      >
                        <Buttons lable={<>View Pdf</>} />
                      </a>
                    )}
                  </PDFDownloadLink>
                </div>
              </Col>
              <Col lg="12" className="mt-3">
                <div className="wire-table table-scroll">
                  <Table responsive>
                    <thead>
                      {formDataStock.product_id ? (
                        <tr>
                          <th className="wrdbrk">S No</th>
                          <th className="wrdbrk">Date</th>
                          <th className="wrdbrk">Receipt No</th>
                          <th className="wrdbrk">Type</th>
                          <th className="wrdbrk">Product</th>
                          <th className="wrdbrk">Category</th>
                          <th className="wrdbrk">Stock</th>
                          <th className="wrdbrk">Sales Rate</th>
                        </tr>
                      ) : (
                        <tr>
                          <th className="wrdbrk">S No</th>
                          <th className="wrdbrk">Product Name</th>
                          <th className="wrdbrk">Category</th>
                          <th className="wrdbrk">Stock</th>
                          <th className="wrdbrk">Sales Rate</th>
                        </tr>
                      )}
                    </thead>
                    <tbody>
                      {formDataStock.product_id
                        ? [
                            ...stockDataProductSales,
                            ...stockDataProductPurchase,
                          ]
                            .map((item) => ({
                              bill_date: item.bill_date,
                              bill_no: item.bill_no,
                              type:
                                item.type ||
                                (item.invoice_id ? "Sale" : "Purchase"),
                              product_name:
                                item.product?.[0]?.product_name || "N/A",
                              category:
                                item.product?.[0]?.category_name || "N/A",
                              stock: item.product?.[0]?.qty || 0,
                              sales_rate: item.product?.[0]?.price_unit || 0,
                            }))
                            .reverse()
                            .map((row, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{formatDate(row.bill_date)}</td>
                                <td>{row.bill_no}</td>
                                <td>{row.type}</td>
                                <td>{row.product_name}</td>
                                <td>{row.category}</td>
                                <td>{row.stock}</td>
                                <td>{row.sales_rate}</td>
                              </tr>
                            ))
                        : productData.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.product_name || "N/A"}</td>
                              <td>{item.category_name || "N/A"}</td>
                              <td>{item.crt_stock || 0}</td>
                              <td>{item.unit_rate || 0}</td>
                            </tr>
                          ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        );

      case "sales":
        const salesPdfFileName = getSalesPDFFilename(
          formDataSales.fromdate,
          formDataSales.todate
        );
        return (
          <div className="all_report_table main my-2">
            <Row className="mx-2">
              <Col lg="6">
                <Buttons
                  lable={<>Download Excel</>}
                  onClick={() =>
                    downloadSalesExcel(
                      stockData,
                      formDataSales.fromdate,
                      formDataSales.todate
                    )
                  }
                />
              </Col>
              <Col lg="6">
                <div className="text-end mx-2">
                  <PDFDownloadLink
                    document={
                      <SaleRep
                        data={stockData}
                        list={stockData}
                        fromdate={formDataSales.fromdate}
                        todate={formDataSales.todate}
                        partyid={formDataSales.party_id}
                      />
                    }
                    fileName={salesPdfFileName}
                  >
                    {({ url }) => (
                      <a
                        role="button"
                        tabIndex="0"
                        href={url}
                        download={salesPdfFileName}
                        rel="noopener noreferrer"
                      >
                        <Buttons lable={<>Download PDF</>} />
                      </a>
                    )}
                  </PDFDownloadLink>
                </div>
              </Col>
              <Col lg="3">
                <DropDownUI
                  key={dropdownKey}
                  optionlist={
                    partyDropdownOptions.length > 0
                      ? partyDropdownOptions
                      : [{ label: "No parties available", value: "" }]
                  }
                  placeholder="Select Party"
                  labelname="Party Name"
                  name="party_id"
                  value={formDataSales.party_id || ""}
                  onChange={(updatedFormData) => {
                    setFormField(
                      updatedFormData.party_id,
                      "party_id",
                      setFormDataSales
                    );
                  }}
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "fromdate", setFormDataSales)
                  }
                  selectedDate={formDataSales.fromdate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "fromdate", setFormDataSales)
                  }
                  calenderlabel="From Date"
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) => setDate(date, "todate", setFormDataSales)}
                  selectedDate={formDataSales.todate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "todate", setFormDataSales)
                  }
                  calenderlabel="To Date"
                />
              </Col>
              <Col lg="3">
                <DropDownUI
                  optionlist={[
                    { label: "All Bills", value: "" },
                    { label: "With GST", value: "with" },
                    { label: "Without GST", value: "without" },
                  ]}
                  placeholder="GST Filter"
                  labelname="GST Filter"
                  name="gst_filter"
                  value={formDataSales.gst_filter || ""}
                  onChange={(updated) => {
                    setFormField(
                      updated.gst_filter,
                      "gst_filter",
                      setFormDataSales
                    );
                  }}
                />
              </Col>

              <Col lg="3" className="d-flex align-items-end">
                <Buttons
                  lable="Clear"
                  onClick={() =>
                    handleClearFilters(setFormDataSales, { ...initialFormData })
                  }
                />
              </Col>
              <Col lg="12">
                <div className="wire-table table-scroll">
                  <Table>
                    <thead>
                      <tr>
                        <th className="wrdbrk">S No</th>
                        <th className="wrdbrk">Date</th>
                        <th className="wrdbrk">Bill No</th>
                        <th className="wrdbrk">Party Name</th>
                        <th className="wrdbrk">GST Number</th>
                        <th className="wrdbrk">Product</th>
                        <th className="wrdbrk">Quantity</th>
                        <th className="wrdbrk">Price</th>
                        <th className="wrdbrk">Sub Total</th>
                        <th className="wrdbrk">Tax Amount</th>
                        <th className="wrdbrk">Discount</th>
                        <th className="wrdbrk">Grand Total</th>
                        <th className="wrdbrk">Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(stockData || [])
                        .filter((item) => {
                          const g = parseFloat(item.gst_amount || 0);

                          if (formDataSales.gst_filter === "with") return g > 0;
                          if (formDataSales.gst_filter === "without")
                            return g === 0;
                          return true;
                        })
                        .reduce((acc, item) => {
                          const products = item.product || [];
                          const taxAmount = products.reduce(
                            (sum, p) =>
                              sum +
                              parseFloat(p.CGST || 0) +
                              parseFloat(p.SGST || 0) +
                              parseFloat(p.IGST || 0),
                            0
                          );

                          acc.push({
                            bill_date: item.bill_date,
                            bill_no: item.bill_no,
                            party_name: item.party_name,
                            mobile_number: item.party_details.gst_no || "N/A",
                            products: products.map((p) => ({
                              name: p.product_name || "N/A",
                              hsn_no: p.hsn_no || "N/A",
                              qty: p.qty || "0",
                              price: p.price_unit || "0",
                            })),
                            sub_total: item.sub_total,
                            tax_amount: taxAmount.toFixed(2),
                            discount: item.discount_amount,
                            total: item.total,
                            paid: item.paid,
                            gst_amount: item.gst_amount,
                            balance: item.balance,
                            payment_method: item.payment_method,
                            remark: item.remark,
                          });

                          return acc;
                        }, [])
                        .sort(
                          (a, b) =>
                            new Date(a.bill_date) - new Date(b.bill_date)
                        )
                        .map((customer, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{formatDate(customer.bill_date)}</td>
                            <td>{customer.bill_no}</td>
                            <td>{customer.party_name}</td>
                            <td>{customer.mobile_number}</td>
                            <td>
                              {customer.products.map((p) => p.name).join(", ")}
                            </td>
                            <td>
                              {customer.products.map((p) => p.qty).join(", ")}
                            </td>
                            <td>
                              {customer.products.map((p) => p.price).join(", ")}
                            </td>
                            <td>{customer.sub_total}</td>
                            <td>{customer.gst_amount}</td>
                            <td>{customer.discount}</td>
                            <td>{customer.total}</td>
                            <td>{customer.remark}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        );
      case "online_sales":
        return (
          <div className="all_report_table main my-2">
            <Row className="mx-2">
              <Col lg="12">
                <div className="fw-bold fs-5 mb-3">Online Sales Report</div>
              </Col>
              <Col lg="6">
                <Buttons
                  lable={<>Download Excel</>}
                  onClick={() =>
                    downloadOnlineSalesExcel(
                      onlineSalesData,
                      formDataOnlineSales.fromdate,
                      formDataOnlineSales.todate
                    )
                  }
                />
              </Col>
              <Col lg="6">
                <div className="text-end mx-2">
                  <PDFDownloadLink
                    document={
                      <OnlineSalesPDF
                        data={onlineSalesData}
                        fromdate={formDataOnlineSales.fromdate}
                        todate={formDataOnlineSales.todate}
                      />
                    }
                    fileName="OnlineSalesReport.pdf"
                  >
                    {({ url }) => (
                      <a
                        role="button"
                        tabIndex="0"
                        href={url}
                        rel="noopener noreferrer"
                      >
                        <Buttons lable={<>View Pdf</>} />
                      </a>
                    )}
                  </PDFDownloadLink>
                </div>
              </Col>
              <Col lg="3">
                <DropDownUI
                  key={dropdownKey}
                  optionlist={onlineSalesData.map((item) => ({
                    label: item.customer_name,
                    value: item.customer_name,
                  }))}
                  placeholder="Select Customer"
                  labelname="Customer Name"
                  name="customer_name"
                  value={formDataOnlineSales.customer_name || ""}
                  onChange={(updatedFormData) =>
                    setFormField(
                      updatedFormData.customer_name,
                      "customer_name",
                      setFormDataOnlineSales
                    )
                  }
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "fromdate", setFormDataOnlineSales)
                  }
                  selectedDate={formDataOnlineSales.fromdate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "fromdate", setFormDataOnlineSales)
                  }
                  calenderlabel="From Date"
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "todate", setFormDataOnlineSales)
                  }
                  selectedDate={formDataOnlineSales.todate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "todate", setFormDataOnlineSales)
                  }
                  calenderlabel="To Date"
                />
              </Col>
              <Col lg="3" className="d-flex align-items-end">
                <Buttons
                  lable="Clear"
                  onClick={() =>
                    handleClearFilters(setFormDataOnlineSales, {
                      ...initialFormData,
                      customer_name: "",
                    })
                  }
                />
              </Col>
              <Col lg="12" className="mt-3">
                <div className="wire-table table-scroll">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th className="wrdbrk">S No</th>
                        <th className="wrdbrk">Enquiry No</th>
                        <th className="wrdbrk">Tax Invoice No</th>
                        <th className="wrdbrk">Customer Name</th>
                        <th className="wrdbrk">Phone</th>
                        {/* <th className="wrdbrk">Products</th> */}
                        <th className="wrdbrk">Quantity</th>
                        <th className="wrdbrk">Total</th>
                        <th className="wrdbrk">Order Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(onlineSalesData || [])
                        .map((item) => {
                          let statusText = "Waiting for confirmation";
                          let statusVariant = "secondary"; // default gray

                          switch (item.status) {
                            case 1:
                              statusText = "Confirmed";
                              statusVariant = "success"; // green
                              break;
                            case 2:
                              statusText = "Packing";
                              statusVariant = "info"; // blue
                              break;
                            case 3:
                              statusText = "Delivered";
                              statusVariant = "warning"; // orange
                              break;
                            case 4:
                              statusText = "Rejected";
                              statusVariant = "danger"; // red
                              break;
                            default:
                              statusText = "Waiting for confirmation";
                              statusVariant = "secondary"; // gray
                          }

                          return {
                            enquiry_no: item.enquiry_no,
                            customer_name: item.customer_name,
                            tax_invoice_no: item.tax_invoice_no,
                            phone: item.phone,
                            products: item.products
                              .map((p) => p.product_name)
                              .join(", "),
                            quantity: item.products.reduce(
                              (sum, p) => sum + parseInt(p.qty || 0, 10),
                              0
                            ),
                            discount_total: item.discount_total,
                            statusText,
                            statusVariant,
                          };
                        })
                        .reverse()
                        .map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{row.enquiry_no}</td>
                            <td>{row.tax_invoice_no}</td>
                            <td>{row.customer_name}</td>
                            <td>{row.phone}</td>
                            {/* <td>{row.products}</td> */}
                            <td>{row.quantity}</td>
                            <td>{row.discount_total}</td>
                            <td>
                              <Badge bg={row.statusVariant}>
                                {row.statusText}
                              </Badge>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        );
      case "purchase":
        return (
          <div className="all_report_table main my-2">
            <Row className="mx-2">
              <Col lg="6">
                <Buttons
                  lable={<>Download Excel</>}
                  onClick={() =>
                    downloadPurchaseExcel(
                      stockDataPurchase,
                      formDataPurchase.fromdate,
                      formDataPurchase.todate
                    )
                  }
                />
              </Col>
              <Col lg="6">
                <div className="text-end mx-2">
                  <PDFDownloadLink
                    document={
                      <PurchaseReport
                        data={stockDataPurchase}
                        fromdate={formDataPurchase.fromdate}
                        todate={formDataPurchase.todate}
                      />
                    }
                    fileName="PurchaseReport.pdf"
                  >
                    {({ url }) => (
                      <a
                        role="button"
                        tabIndex="0"
                        href={url}
                        rel="noopener noreferrer"
                      >
                        <Buttons lable={<>View Pdf</>} />
                      </a>
                    )}
                  </PDFDownloadLink>
                </div>
              </Col>
              <Col lg="3">
                <DropDownUI
                  key={dropdownKey}
                  optionlist={userDataPurchaseParty.map((item) => ({
                    label: item.party_name,
                    value: item.party_id,
                  }))}
                  placeholder="Select Party"
                  labelname="Party Name"
                  name="party_id"
                  value={formDataPurchase.party_id || ""}
                  onChange={(updatedFormData) =>
                    setFormField(
                      updatedFormData.party_id,
                      "party_id",
                      setFormDataPurchase
                    )
                  }
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "fromdate", setFormDataPurchase)
                  }
                  selectedDate={formDataPurchase.fromdate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "fromdate", setFormDataPurchase)
                  }
                  calenderlabel="From Date"
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "todate", setFormDataPurchase)
                  }
                  selectedDate={formDataPurchase.todate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "todate", setFormDataPurchase)
                  }
                  calenderlabel="To Date"
                />
              </Col>
              <Col lg="3" className="d-flex align-items-end">
                <Buttons
                  lable="Clear"
                  onClick={() =>
                    handleClearFilters(setFormDataPurchase, {
                      ...initialFormData,
                    })
                  }
                />
              </Col>
              <Col lg="12">
                <div className="wire-table table-scroll">
                  <Table>
                    <thead>
                      <tr>
                        <th className="wrdbrk">S No</th>
                        <th className="wrdbrk">Date</th>
                        <th className="wrdbrk">Bill No</th>
                        <th className="wrdbrk">Party Name</th>
                        <th className="wrdbrk">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(stockDataPurchase || [])
                        .map((item, index) => ({
                          bill_date: item.bill_date,
                          bill_no: item.bill_no,
                          party_name:
                            item.party_details?.party_name ||
                            item.party_name ||
                            "N/A",
                          total: item.total || 0,
                        }))
                        .reverse()
                        .map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{row.bill_date}</td>
                            <td>{row.bill_no}</td>
                            <td>{row.party_name}</td>
                            <td>{row.total}</td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        );

      case "expense":
        const totalExpense = (expItemData || []).reduce(
          (sum, item) => sum + (parseFloat(item.total || item.amount) || 0),
          0
        );

        return (
          <div className="all_report_table main my-2">
            <Row className="mx-2">
              <Col lg="12">
                <div className="fw-bold fs-5 mb-3">
                  Total Expenses: ₹
                  {totalExpense.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </div>
              </Col>
              <Col lg="6">
                <Buttons
                  lable={<>Download Excel</>}
                  onClick={() =>
                    ExpenseExcel(expItemData, expCategoryData, totalExpense)
                  }
                />
              </Col>
              <Col lg="6">
                <div className="text-end mx-2">
                  <PDFDownloadLink
                    document={
                      <ExpensePDF
                        data={expItemData}
                        category={expCategoryData}
                        fromdate={formDataExpense.fromdate}
                        todate={formDataExpense.todate}
                        total={totalExpense}
                      />
                    }
                    fileName="ExpenseReport.pdf"
                  >
                    {({ url }) => (
                      <a
                        role="button"
                        tabIndex="0"
                        href={url}
                        rel="noopener noreferrer"
                      >
                        <Buttons lable={<>View Pdf</>} />
                      </a>
                    )}
                  </PDFDownloadLink>
                </div>
              </Col>
              <Col lg="3">
                <DropDownUI
                  key={dropdownKey}
                  optionlist={expCategoryData.map((item) => ({
                    label: item.category_name,
                    value: item.category_id,
                  }))}
                  placeholder="Select Category"
                  labelname="Expense Category"
                  name="category_id"
                  value={formDataExpense.category_id || ""}
                  onChange={(updatedFormData) =>
                    setFormField(
                      updatedFormData.category_id,
                      "category_id",
                      setFormDataExpense
                    )
                  }
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "fromdate", setFormDataExpense)
                  }
                  selectedDate={formDataExpense.fromdate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "fromdate", setFormDataExpense)
                  }
                  calenderlabel="From Date"
                />
              </Col>
              <Col lg="3">
                <Calender
                  key={dropdownKey}
                  setLabel={(date) =>
                    setDate(date, "todate", setFormDataExpense)
                  }
                  selectedDate={formDataExpense.todate || ""}
                  onSelectDate={(date) =>
                    setDate(date, "todate", setFormDataExpense)
                  }
                  calenderlabel="To Date"
                />
              </Col>
              <Col lg="3" className="d-flex align-items-end">
                <Buttons
                  lable="Clear"
                  onClick={() =>
                    handleClearFilters(setFormDataExpense, {
                      ...initialFormData,
                    })
                  }
                />
              </Col>
              <Col lg="12">
                <div className="wire-table table-scroll mt-3">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th className="wrdbrk">S No</th>
                        <th className="wrdbrk">Date</th>
                        <th className="wrdbrk">Expense Category</th>
                        <th className="wrdbrk">Expense Name</th>
                        <th className="wrdbrk">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(expItemData || [])
                        .map((item, index) => {
                          const category = expCategoryData.find(
                            (cat) => cat.category_id === item.category_id
                          );
                          return {
                            bill_date: item.bill_date || "N/A",
                            expense_name:
                              item.expense_name || item.party_name || "N/A",
                            amount: item.total || item.amount || 0,
                            category_name: category
                              ? category.category_name
                              : "Uncategorized",
                          };
                        })
                        .reverse()
                        .map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{formatDate(row.bill_date)}</td>
                            <td>{row.category_name}</td>
                            <td>{row.expense_name}</td>
                            <td>{row.amount}</td>
                          </tr>
                        ))}
                      <tr>
                        <td
                          colSpan="4"
                          className="text-end fw-bold"
                          style={{ textAlign: "right" }}
                        >
                          Total:
                        </td>
                        <td className="fw-bold">
                          {totalExpense.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        );

      default:
        return null;
    }
  };

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid>
        <Row>
          <Col lg="12">
            <div className="main my-2 stick-top">
              <div className="report-title py-3 mx-2">Transaction Reports</div>
              <div className="report">
                <Nav className="py-3">
                  {/* <li>
                    <Nav.Link
                      onClick={() => setActiveTab("Stock")}
                      className={
                        activeTab === "Stock" ? "navlink active" : "navlink"
                      }
                    >
                      Stock
                    </Nav.Link>
                  </li> */}
                  <li>
                    <Nav.Link
                      onClick={() => setActiveTab("sales")}
                      className={
                        activeTab === "sales" ? "navlink active" : "navlink"
                      }
                    >
                      Sales
                    </Nav.Link>
                  </li>
                  {/* <li>
                    <Nav.Link
                      onClick={() => setActiveTab("online_sales")}
                      className={
                        activeTab === "online_sales"
                          ? "navlink active"
                          : "navlink"
                      }
                    >
                      Online Sales
                    </Nav.Link>
                  </li> */}
                  <li>
                    <Nav.Link
                      onClick={() => setActiveTab("purchase")}
                      className={
                        activeTab === "purchase" ? "navlink active" : "navlink"
                      }
                    >
                      Purchase
                    </Nav.Link>
                  </li>
                  <li>
                    <Nav.Link
                      onClick={() => setActiveTab("expense")}
                      className={
                        activeTab === "expense" ? "navlink active" : "navlink"
                      }
                    >
                      Expense
                    </Nav.Link>
                  </li>
                </Nav>
              </div>
            </div>
          </Col>
          <Col lg="12" className="py-2">
            <div>{renderContent()}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Reports;
